var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpo = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 -12.5 256 256",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000020",
  d: "M121.3 84.67c2.1-3.08 4.4-3.47 6.25-3.47 1.86 0 4.96.39 7.05 3.47 16.5 22.67 43.75 67.82 63.84 101.13 13.1 21.72 23.17 38.4 25.23 40.52 7.75 7.97 18.38 3 24.56-6.03 6.08-8.9 7.77-15.15 7.77-21.82 0-4.54-88.1-168.4-96.98-182.04C150.5 3.31 147.71 0 133.11 0h-10.93c-14.56 0-16.67 3.31-25.2 16.43C88.1 30.07 0 193.93 0 198.47c0 6.67 1.69 12.92 7.77 21.82 6.18 9.04 16.8 14 24.56 6.03 2.06-2.12 12.13-18.8 25.23-40.52 20.1-33.3 47.25-78.46 63.75-101.13"
})));
export default SvgExpo;